var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgSearchMissing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4023 0.808838C4.88234 0.808838 0.402344 5.28884 0.402344 10.8088C0.402344 16.3288 4.88234 20.8088 10.4023 20.8088C15.9223 20.8088 20.4023 16.3288 20.4023 10.8088C20.4023 5.28884 15.9223 0.808838 10.4023 0.808838ZM10.9023 17.8088H9.90234C9.62634 17.8088 9.40234 17.5848 9.40234 17.3088V16.3088C9.40234 16.0328 9.62634 15.8088 9.90234 15.8088H10.9023C11.1783 15.8088 11.4023 16.0328 11.4023 16.3088V17.3088C11.4023 17.5848 11.1783 17.8088 10.9023 17.8088ZM13.4723 10.0588L12.5723 10.9788C11.8523 11.7088 11.4023 12.3088 11.4023 13.8088H9.40234V13.3088C9.40234 12.2088 9.85234 11.2088 10.5723 10.4788L11.8123 9.21884C12.2693 8.77484 12.4973 8.11684 12.3653 7.41584C12.2303 6.69884 11.6773 6.08884 10.9763 5.88984C9.87034 5.57584 8.83934 6.20884 8.51034 7.16184C8.38234 7.53284 8.07034 7.80884 7.67734 7.80884H7.38634C6.80534 7.80884 6.39934 7.24484 6.56134 6.68684C6.99034 5.21484 8.24234 4.09384 9.78634 3.85584C11.3103 3.62084 12.7553 4.40484 13.6593 5.65484C14.8393 7.28684 14.4913 9.03984 13.4723 10.0588Z",
    fill: "#555E6D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchMissing);
export default __webpack_public_path__ + "static/media/search_missing.b2a7692e7e0463f07c35b18e61955381.svg";
export { ForwardRef as ReactComponent };